import { makeId } from '@/utils/makeId'

export type Topping = {
  id: string
  name: string
  description: string
  price: number
}

export const toppings: Topping[] = [
  {
    id: makeId(),
    name: 'Ganache de Chocolate',
    description: 'Ganache feito com chocolate nobre',
    price: 7.99,
  },
  {
    id: makeId(),
    name: 'ChantiNinho®',
    description: 'Mistura de chantilly com Ninho® original',
    price: 7.99,
  },
]
